/**
 * Formats a number to a human-readable format or returns 0 if not a number
 * @param {*} value - The value to format
 * @returns {string|number} - Formatted string if number, 0 otherwise
 */
export function formatNumberForDisplay(value) {
	if (value === null || value === undefined || isNaN(Number(value))) {
		return 0;
	}
	return new Intl.NumberFormat('en-US').format(Number(value));
}



// WEBPACK FOOTER //
// ./src/assets/js/lib/number-format-lib.js